import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from 'app/auth/auth.service';
import { DATOS_API } from 'app/auth/auth.datos';

@Injectable({
  providedIn: 'root'
})
export class CrearEncuestaService {

  idEmpresa: string;
  idUsuario: string;
  idInstituto: string;

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
    this.obtienInfo();
  }

  obtienInfo()
  {
    this.idUsuario = this.authService.getIdUsuario();
    this.idInstituto = this.authService.getInstituto();
    let infoUsu: any = this.authService.getInfoUsuario();
    // console.log(infoUsu);
    this.idEmpresa = infoUsu.empresaId;
  }

  getStatusSeccCreacionEncuesta(idProducto?:string){
    this.obtienInfo();
    let datos: any = {productoId: idProducto, encuesta:1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.wizardEnc.getStatus + this.idEmpresa, datos);
  }


  saveStatusSeccCreacionEncuesta(datos: any){
    // let datos: any = {productoId: anio,	encuesta: 3};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.wizardEnc.sendStatus + this.idEmpresa, datos);
  }

}
